import { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Button } from "react-bootstrap"
import { changePasswordAction, clearChangePasswordState } from "../../../../store/actions/ChangePasswordAction"
import Swal from "sweetalert2"
import Loader from "../../Common/Loader"

const ChangePassword = ({ loading, success, error, message, changePasswordAction, clearChangePasswordState }) => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  })

  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [validationErrors, setValidationErrors] = useState({})

  // Clear state when component unmounts
  useEffect(() => {
    return () => {
      clearChangePasswordState()
    }
  }, [clearChangePasswordState])

  // Clear form after successful password change
  useEffect(() => {
    if (success) {
      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      })
      setValidationErrors({})
    }
  }, [success])

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))

    // Clear validation error for this field
    if (validationErrors[name]) {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: "",
      }))
    }
  }

  // Validate form
  const validateForm = () => {
    const errors = {}

    if (!formData.currentPassword) {
      errors.currentPassword = "Current password is required"
    }

    if (!formData.newPassword) {
      errors.newPassword = "New password is required"
    } else if (formData.newPassword.length < 6) {
      errors.newPassword = "New password must be at least 6 characters"
    }

    if (!formData.confirmNewPassword) {
      errors.confirmNewPassword = "Please confirm your new password"
    } else if (formData.newPassword !== formData.confirmNewPassword) {
      errors.confirmNewPassword = "Passwords do not match"
    }

    if (formData.currentPassword === formData.newPassword) {
      errors.newPassword = "New password must be different from current password"
    }

    return errors
  }

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validateForm()
    setValidationErrors(errors)

    if (Object.keys(errors).length > 0) {
      return
    }

    try {
      await changePasswordAction(formData)
    
      Swal.fire({
        icon: "success",
        title: "Password Changed",
        text: "Your password has been successfully updated!",
      })
    } catch (err) {
      const apiMessage =
        err?.response?.data?.messages?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to change password"
    
      // Show only inline error
      if (apiMessage.toLowerCase().includes("current")) {
        setValidationErrors((prev) => ({
          ...prev,
          currentPassword: apiMessage,
        }))
      } else {
        // Optional: show generic error inline or console
        console.error(apiMessage)
    
        setValidationErrors((prev) => ({
          ...prev,
          general: apiMessage,   // if you want to show at top of form
        }))
      }
    }
    

  }

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title mb-4">Change Password</h4>

              <form onSubmit={handleSubmit}>
                {/* <div className="mb-3">
                  <label className="form-label">
                    Current Password <span className="text-danger">*</span>
                  </label>
                  <input
                    type="password"
                    name="currentPassword"
                    className={`form-control ${validationErrors.currentPassword ? "is-invalid" : ""}`}
                    placeholder="Enter your current password"
                    value={formData.currentPassword}
                    onChange={handleInputChange}
                  />
                    <span className="input-group-text" onClick={() =>
      setShowPassword((prev) => ({ ...prev, current: !prev.current }))
    } style={{ cursor: "pointer" }}>
      <i className={`fa ${showPassword.current ? "fa-eye-slash" : "fa-eye"} fs-5`} />
    </span>
                  {validationErrors.currentPassword && (
                    <div className="invalid-feedback">{validationErrors.currentPassword}</div>
                  )}
                </div> */}
                <div className="mb-3">
                  <label className="form-label">
                    Current Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword.current ? "text" : "password"} // <-- This must change based on state!
                      name="currentPassword"
                      className={`form-control ${validationErrors.currentPassword ? "is-invalid" : ""}`}
                      placeholder="Enter your current password"
                      value={formData.currentPassword}
                      onChange={handleInputChange}
                    />
                    <span
                      className="input-group-text"
                      onClick={() =>
                        setShowPassword((prev) => ({ ...prev, current: !prev.current }))
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <i className={`fa ${showPassword.current ? "fa-eye" : "fa-eye-slash"} fs-5`} />
                    </span>
                    {validationErrors.currentPassword && (
                      <div className="invalid-feedback d-block">
                        {validationErrors.currentPassword}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    New Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword.new ? "text" : "password"}
                      name="newPassword"
                      className={`form-control ${validationErrors.newPassword ? "is-invalid" : ""}`}
                      placeholder="Enter your new password"
                      value={formData.newPassword}
                      onChange={handleInputChange}
                    />
                    <span
                      className="input-group-text"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setShowPassword((prev) => ({ ...prev, new: !prev.new }))
                      }
                    >
                      <i className={`fa ${showPassword.new ? "fa-eye" : "fa-eye-slash"} fs-5`} />
                    </span>
                    {validationErrors.newPassword && (
                      <div className="invalid-feedback d-block">{validationErrors.newPassword}</div>
                    )}
                  </div>
                </div>


                <div className="mb-3">
                  <label className="form-label">
                    Confirm New Password <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword.confirm ? "text" : "password"}
                      name="confirmNewPassword"
                      className={`form-control ${validationErrors.confirmNewPassword ? "is-invalid" : ""}`}
                      placeholder="Confirm your new password"
                      value={formData.confirmNewPassword}
                      onChange={handleInputChange}
                    />
                    <span
                      className="input-group-text"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setShowPassword((prev) => ({ ...prev, confirm: !prev.confirm }))
                      }
                    >
                      <i className={`fa ${showPassword.confirm ? "fa-eye" : "fa-eye-slash"} fs-5`} />
                    </span>
                    {validationErrors.confirmNewPassword && (
                      <div className="invalid-feedback d-block">{validationErrors.confirmNewPassword}</div>
                    )}
                  </div>
                </div>


                <div className="d-flex gap-2">
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <Loader className="me-2" />
                        Changing Password...
                      </>
                    ) : (
                      "Change Password"
                    )}
                  </Button>

                  <Button
                    variant="info"
                    type="button"
                    onClick={() => {
                      setFormData({
                        currentPassword: "",
                        newPassword: "",
                        confirmNewPassword: "",
                      })
                      setValidationErrors({})
                      clearChangePasswordState()
                    }}
                    disabled={loading}
                  >
                    Reset
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  loading: state.changePassword.loading,
  success: state.changePassword.success,
  error: state.changePassword.error,
  message: state.changePassword.message,
})

const mapDispatchToProps = {
  changePasswordAction,
  clearChangePasswordState,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
